interface KpiCardProps {
  title: string;
  value: string;
  subValue?: string;
  delta?: string;
  deltaPositive?: boolean;
}

export function KpiCard({ title, value, subValue, delta, deltaPositive = true }: KpiCardProps) {
  return (
    <div className="bg-white dark:bg-surface-secondary rounded-xl border-[0.5px] border-[#E8E6F8] dark:border-theme-light p-4">
      <p className="text-[11px] font-medium uppercase tracking-[0.5px] text-[#888780] dark:text-theme-tertiary">{title}</p>
      <p className="text-[26px] font-semibold text-[#1A1A18] dark:text-theme mt-1 leading-none">{value}</p>
      {subValue && <p className="text-[12px] text-[#888780] dark:text-theme-tertiary mt-1.5">{subValue}</p>}
      {delta && (
        <p
          className={`text-[12px] font-medium mt-1 ${
            deltaPositive ? 'text-[#3C9F3C] dark:text-green-400' : 'text-[#D64545] dark:text-red-400'
          }`}
        >
          {delta}
        </p>
      )}
    </div>
  );
}
